export default {
  systemTemplate: '系统模板',
  myTemplate: '我的模板',
  customCreate: '自定义创建',
  newTemplate: '新建模板',
  emptyMyTemplate: '暂无模板',
  syncLang: '同步配置',
  syncLangTitle: '同步配置到其他语言',
  syncLangDesc: '将当前语言（{lang}）的模板配置同步到以下选中的语言，目标语言的原有配置将被覆盖。',
  syncLangSuccess: '同步配置成功',
};
